import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_POSIBLES_ARRIBOS } from '../../../../../config/tables'

function TablaPosiblesArribosView () {
  return <MuiTable id={TABLA_POSIBLES_ARRIBOS} />
}

export default TablaPosiblesArribosView
